var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZebu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 50,
    viewBox: "0 0 400 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.2 105.8C128.8 120.4 136 127 148.6 127C157.8 127 165.2 121.4 166.6 116.2H186.8C180.4 135.8 166.6 144.2 147.8 144.2C121.6 144.2 105.2 126.2 105.2 100.4C105.2 75.4 122.4 56.4 147.8 56.4C176.4 56.2 190 80 188.4 105.8H128.2ZM165.4 91.2C163.2 79.6 158.2 73.4 147.2 73.4C132.6 73.4 128.4 84.6 128.2 91.2H165.4Z",
    fill: "#0037B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.6 71L25.7998 47V68L77.5998 84.6L25.7998 101.4V103.2V122.2V122.4L79.1998 105.2L100.6 98.4V71.2V71Z",
    fill: "#0037B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.4 122.4H25.7998V141.8H100.4V122.4Z",
    fill: "#0037B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M242.799 56.2C232.399 56.2 222.199 60 216.599 68.6H216.199V26.6L193.399 34V141.8H215.199V131.2H215.599C220.599 140.4 230.799 144.2 242.999 144.2C259.599 144.2 277.599 130.8 277.599 100.2C277.399 69.6 259.399 56.2 242.799 56.2ZM234.999 126.8C221.399 126.8 215.399 114 215.399 100.2C215.399 86.2 221.399 73.4 234.999 73.4C248.599 73.4 254.599 86.2 254.599 100.2C254.399 114.2 248.599 126.8 234.999 126.8Z",
    fill: "#0037B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M337.6 102.2C337.6 119.2 332.2 126 319.8 126C309.2 126 305.2 119.2 305.2 105.6V58.4L282.2 65.8V109.8C282.2 130.4 288.4 144.2 312.6 144.2C322.2 144.2 332.2 139.6 338 130.4H338.4V142H360.2V58.4L337.2 65.8L337.6 102.2Z",
    fill: "#0037B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2002 165.6H37.0002C40.0002 165.6 42.2002 166.4 43.8002 168C45.2002 169.4 45.8002 171.2 45.8002 173.4C45.8002 177.2 43.8002 179.6 40.8002 180.6L46.6002 189H40.6002L35.6002 181.4H31.6002V189H26.4002L26.2002 165.6ZM36.6002 177C39.2002 177 40.6002 175.6 40.6002 173.6C40.6002 171.4 39.0002 170.2 36.6002 170.2H31.4002V177C31.4002 177 36.6002 177 36.6002 177Z",
    fill: "#0037B7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3994 165.6H68.1994V170.2H55.5994V174.8H66.5994V179.4H55.5994V184.4H68.3994V189H50.3994V165.6Z",
    fill: "#0037B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73 165.6H78V184.2H89.8V189H73V165.6Z",
    fill: "#0037B7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9998 165.6H93.7998V189H98.9998V165.6Z",
    fill: "#0037B7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113 165.4H117.8L127.8 189H122.4L120.2 183.8H110.2L108 189H102.8L113 165.4ZM118.4 179.2L115.2 171.6L112 179.2H118.4Z",
    fill: "#0037B7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.399 165.6H142.199C144.799 165.6 146.999 166.4 148.399 167.6C149.399 168.6 149.999 170 149.999 171.6C149.999 174.2 148.599 175.8 146.999 176.6C149.799 177.6 151.399 179.2 151.399 182.4C151.399 186.6 147.999 188.8 142.599 188.8H131.399V165.6ZM141.199 175C143.399 175 144.999 174.2 144.999 172.6C144.999 171 143.799 170.2 141.599 170.2H136.599V175.2L141.199 175ZM142.599 184.4C144.799 184.4 146.199 183.6 146.199 181.8C146.199 180.2 144.999 179.2 142.399 179.2H136.399V184.4H142.599Z",
    fill: "#0037B7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.6 165.6H160.8V184.2H172.4V189H155.6V165.6Z",
    fill: "#0037B7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M176.2 165.6H194V170.2H181.4V174.8H192.4V179.4H181.4V184.4H194.2V189H176.2V165.6Z",
    fill: "#0037B7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M203.4 183.6H198V189H203.4V183.6Z",
    fill: "#0037B7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M226.4 165.4H231.2L241.2 189H235.8L233.6 183.8H223.6L221.4 189H216.2L226.4 165.4ZM231.8 179.2L228.6 171.6L225.4 179.2H231.8Z",
    fill: "#0037B7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M244.8 165.6H250V184.2H261.6V189H244.8V165.6Z",
    fill: "#0037B7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M260.399 165.6H265.999L270.799 181.4L275.999 165.4H280.399L285.799 181.4L290.599 165.6H295.999L287.999 189.2H283.399L278.199 173.8L272.799 189.2H268.399L260.399 165.6Z",
    fill: "#0037B7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M304.8 165.4H309.6L319.6 189H314.2L312 183.8H302L299.8 189H294.6L304.8 165.4ZM310.2 179.2L307 171.6L303.8 179.2H310.2Z",
    fill: "#0037B7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M326.2 179.8L317.2 165.6H323.2L328.8 175L334.4 165.6H340.4L331.4 179.6V189H326.2V179.8Z",
    fill: "#0037B7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M340.8 185.6L343.8 182C346 183.8 348.2 184.8 350.8 184.8C353 184.8 354.2 184 354.2 182.6C354.2 181.2 353.4 180.6 349.4 179.6C344.6 178.4 341.6 177 341.6 172.4C341.6 168.2 345 165.4 349.8 165.4C353.2 165.4 356.2 166.4 358.6 168.4L356 172C354 170.6 351.8 169.6 350 169.6C348.2 169.6 347 170.6 347 171.6C347 173.2 348 173.6 352 174.6C356.8 175.8 359.4 177.6 359.4 181.6C359.4 186.2 355.8 188.8 350.8 188.8C347.2 189.4 343.6 188 340.8 185.6Z",
    fill: "#0037B7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M368.4 183.6H363V189H368.4V183.6Z",
    fill: "#0037B7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M376.621 49.3999V51.242H373.463V59.6631H371.358V51.242H368.2V49.3999H376.621Z",
    fill: "#0037B7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M385.042 49.3999H388.2V59.6631H386.095V52.821C386.095 52.5578 386.095 52.2946 386.095 52.0315C386.095 51.7683 386.095 51.5052 386.095 51.242L383.99 59.9262H381.884L379.779 51.242C379.779 51.5052 379.779 51.7683 379.779 52.0315C379.779 52.2946 379.779 52.5578 379.779 52.821V59.6631H377.674V49.3999H380.832L382.674 57.5578L385.042 49.3999Z",
    fill: "#0037B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZebu);
export default __webpack_public_path__ + "static/media/zebu.20b6a36c0ea17eea5e086ce86fc07014.svg";
export { ForwardRef as ReactComponent };